<template>
  <div>
    <TransferListFilters />

    <v-card outlined>
      <v-data-table
        v-model="selectedTransfers"
        @dblclick:row="showTransferRow"
        :items="transfers"
        :headers="headers"
        :loading="isLoading"
        :items-per-page="30"
        :no-data-text="$t('transfer.noData')"
        :loading-text="$t('appointment.table.loading')"
        class="clickable hideSelectAll"
        mobile-breakpoint="20"
        hide-default-footer
        disable-sort
        show-select
      >
        <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
          <v-simple-checkbox
            @input="select($event)"
            :disabled="isReceiverAHost(item.receiver_type) || isTransferNotFailed(item.status)"
            :value="isSelected"
            class="pa-0"
            hide-details
            dense
          />
        </template>
        <template v-slot:[`item.host`]="{ item }">
          {{ getNames(item) }}
        </template>
        <template v-slot:[`item.receiver_type`]="{ item }">
          {{
            item.receiver_type
              ? $t(`transfer.receiverType.${item.receiver_type}`)
              : '---'
          }}
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          <span v-if="item.created_at">
            {{ formatDate(item.created_at) }}
          </span>
          <span v-else>---</span>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip v-if="item.status" :color="handleColors(item.status)" small>
            {{ $t(`transfer.transferStatus.${item.status}`) }}
          </v-chip>
          <span v-else>---</span>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <span v-if="item.total">
            {{ formatMoney(item.total) }}
          </span>
          <span v-else>---</span>
        </template>
        <template v-slot:[`item.asaas_transfer_id`]="{ item }">
          <v-chip v-if="item.asaas_transfer_id" small>
            {{ item.asaas_transfer_id }}
            <CopyToClipboard :value="item.asaas_transfer_id" />
          </v-chip>
          <span v-else>---</span>
        </template>
        <template v-slot:[`item.appointment`]="{ item }">
          <v-btn
            v-if="item.appointment"
            :href="`/admin-appointment/${item.appointment.id}`"
            target="_blank"
            color="primary"
            small
            text
          >
            <v-icon small left>
              mdi-open-in-new
            </v-icon>
            <span class="body-2">
              {{ item.appointment.code }}
            </span>
          </v-btn>
          <span v-else>---</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="showTransfer(item.id)"
                class="mx-1"
                icon
              >
                <v-icon small>
                  mdi-eye
                </v-icon>
              </v-btn>
            </template>
            <span class="body-2">
              {{ $t('transfer.label.visualize') }}
            </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <h-pagination :fetch="fetchTransfers" :requireOrderByFilter="false" />

    <TransferConfirmModal
      :parsedTransfers="parsedTransfers"
      :selectedTransfers="selectedTransfers"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { transferHeaders } from './listHeaders/transferHeaders'
import { catalogDate, catalogMonetary } from '@/util/catalog'
import { handleColors } from '@/util/colors'
import { receiverType } from '@/util/enums'

import TransferConfirmModal from '@/components/transfer/modal/TransferConfirmModal'
import TransferListFilters from '@/components/transfer/TransferListFilters'
import CopyToClipboard from '@/components/app/CopyToClipboard'

export default {
  name: 'TransferList',

  components: {
    TransferConfirmModal,
    TransferListFilters,
    CopyToClipboard,
  },

  watch: {
    selectedTransfers(transfers) {
      if (transfers && transfers.length > 0) {
        this.parsedTransfers = transfers.map(transfer => transfer.id)
      }
    }
  },

  computed: {
    ...mapGetters([
      'isLoading',
      'transfers',
      'isGeneratingReport',
    ]),
  },

  watch: {
    selectedTransfers(transfers) {
      if (transfers && transfers.length > 0) {
        this.parsedTransfers = transfers.map(transfer => transfer.id)
      }
    }
  },

  methods: {
    ...mapMutations(['openModal']),
    ...mapActions(['fetchTransfers', 'retryTransfer']),

    isReceiverAHost(type) {
      return type === 'HOST'
    },

    isTransferNotFailed(status) {
      return ['PROCESSING', 'COMPLETED'].includes(status)
    },

    showTransfer(id) {
      window.open(`/transfer/${id}`)
    },

    showTransferRow(_, { item }) {
      this.showTransfer(item.id)
    },

    resetSelected() {
      this.parsedTransfers = []
      this.selectedTransfers = []
    },

    getNames(item) {
      switch(item?.receiver_type) {
        case('HOST'):
          return item?.host?.name
        case('VENDOR'):
          return item?.vendor?.name
        case('PARTNER'):
          return item?.partner?.name
        default:
          return '---'
      }
    },
  },

  data() {
    return {
      headers: transferHeaders,
      formatDate: catalogDate,
      formatMoney: catalogMonetary,
      selectedTransfers: [],
      parsedTransfers: [],
      handleColors,
      receiverType,
    }
  },
}
</script>
